(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["papeh-pdp-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    const holidays = ["2019-01-01", "2019-04-19", "2019-04-22", "2019-05-06", "2019-05-27", "2019-08-26", "2019-12-25", "2019-12-26", "2020-01-01", "2020-04-10", "2020-04-13", "2020-05-08", "2020-05-25", "2020-08-31", "2020-12-25", "2020-12-28", "2021-01-01", "2021-04-02", "2021-04-05", "2021-05-03", "2021-05-31", "2021-08-30", "2021-12-27", "2021-12-28", "2022-01-03", "2022-04-15", "2022-04-18", "2022-05-02", "2022-06-02", "2022-06-03", "2022-08-29", "2022-09-19", "2022-12-26", "2022-12-27", "2023-01-02", "2023-04-07", "2023-04-10", "2023-05-01", "2023-05-08", "2023-05-29", "2023-08-28", "2023-12-25", "2023-12-26", "2024-01-01", "2024-03-29", "2024-04-01", "2024-05-06", "2024-05-27", "2024-08-26", "2024-12-25", "2024-12-26", "2025-01-01", "2025-04-18", "2025-04-21", "2025-05-05", "2025-05-26", "2025-08-25", "2025-12-25", "2025-12-26", "2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25", "2026-08-31", "2026-12-25", "2026-12-28", "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31", "2027-08-30", "2027-12-27", "2027-12-28", "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29", "2028-08-28", "2028-12-25", "2028-12-26"];
    const businessDay = (date) => ![0, 6].includes(date.getUTCDay()) && !holidays.includes(date.toISOString().slice(0, 10));
    const update = () => {
      const now = new Date();
      const date = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      const rolledOver = now.getUTCHours() >= 17 || !businessDay(date);

if (now.getUTCHours() >= 17) {
  date.setUTCDate(date.getUTCDate() + 1);
}

while (!businessDay(date)) {
  date.setUTCDate(date.getUTCDate() + 1);
}

let remaining = rolledOver ? 1 : 2;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (businessDay(date)) remaining -= 1;
      }
      const label = new Intl.DateTimeFormat('en-GB', {weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC'}).format(date).replace(/^(\S+) /, '$1. ');
      document.querySelectorAll('[data-papeh-dispatch-date]').forEach((element) => { element.textContent = label; });
    };
    update();
    document.addEventListener('shopify:section:load', update);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
    setInterval(update, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
